var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "51px",
    viewBox: "0 0 45 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 40.6587302,
    height: 47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4A4A4A",
    x: 8,
    y: 31,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12.5 C13,11.672 13.672,11 14.5,11 C15.328,11 16,11.672 16,12.5 C16,13.329 15.328,14 14.5,14 C13.672,14 13,13.329 13,12.5 Z M24.9285714,14 L21.8697857,18.5 L18.8571429,16.295 L14,23 L31,23 L24.9285714,14 Z M34,8 L34,25 L10,25 L10,8 L34,8 Z M36,6 L8,6 L8,27 L36,27 L36,6 Z",
    id: "Shape-Copy-10",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,39 C9.34325,39 8,40.34325 8,42 C8,43.65675 9.34325,45 11,45 C12.65675,45 14,43.65675 14,42 C14,40.34325 12.65675,39 11,39 Z",
    id: "Path",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,39 C17.34325,39 16,40.34325 16,42 C16,43.65675 17.34325,45 19,45 C20.65675,45 22,43.65675 22,42 C22,40.34325 20.65675,39 19,39 Z",
    id: "Path-Copy-7",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,39 C25.34325,39 24,40.34325 24,42 C24,43.65675 25.34325,45 27,45 C28.65675,45 30,43.65675 30,42 C30,40.34325 28.65675,39 27,39 Z",
    id: "Path-Copy-8",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/Card 2.8a582ef5.svg";
export { ForwardRef as ReactComponent };